import { Button, Text, HStack } from '@chakra-ui/react';
import { ReactComponent as PlusIcon } from '../../../logos/plusIcon.svg';

const NewChatButton = ({
  setActiveConversationId,
  setMessages,
  isDisabled,
  setSearchResults,
}) => {
  return (
    <Button
      bg='#EC9F24'
      color='#FFFFFF'
      flexGrow={1}
      isDisabled={isDisabled}
      onClick={() => {
        if (!isDisabled) {
          setActiveConversationId('');
          setMessages([]);
          setSearchResults(null);
        }
      }}
    >
      <HStack spacing={2}>
        <PlusIcon height='14px' width='14px' />
        <Text fontSize='14px'>New Chat</Text>
      </HStack>
    </Button>
  );
};

export default NewChatButton;
